<template>
    <v-container class="ma-0 pa-0" fluid>
        <v-layout row>
            <v-flex xs12 sm6 md6 offset-sm3 mt-12>
                <v-card class="pa-2">
                    <v-card-title class="justify-center" cols="12">Give Us Feedback to Improve</v-card-title>
                    <v-textarea
                        outlined
                        name="Feedback"
                        label="Tell us what you like or what we can do better"
                        v-model="feedbackContent"
                        v-validate="'required'"
                        data-vv-name="Feedback"
                        data-cy="Feedback"
                        :error-messages="errors.collect('Feedback')"
                    ></v-textarea>
                    <v-card-actions>
                        <v-btn color="blue" text @click="close">
                            Close
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :loading="sending" :disabled="sending" color="blue" text @click="save">
                            Send Feedback
                        </v-btn>
                    </v-card-actions>
                    <v-footer padless>
                        <v-col class="text-center font-weight-light" cols="12">
                            Need support? Contact 403-993-7761 or email support@ajmenv.com
                        </v-col>
                    </v-footer>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import { authHeader } from '../_helpers'

export default {
    $_veeValidate: {
        validator: 'new' // give me a new validator each time.
    },
    data() {
        return {
            feedbackContent: '',
            sending: false
        }
    },
    methods: {
        save() {
            let app = this
            app.$validator
                .validateAll()
                .then(validated => {
                    if (validated) {
                        app.sendFeedback()
                    }
                })
                .catch(() => {
                    return false
                })
        },
        sendFeedback() {
            const app = this
            let params = {
                feedbackContent: this.feedbackContent,
                userId: this.$store.state.authentication.loggedInUser.userId
            }
            app.sending = true
            axios
                .post(app.$store.state.userUrl + '/feedback', params, { headers: authHeader() })
                .then(response => {
                    this.feedbackContent = ''
                    app.sending = false
                    let snackbarParams = {
                        message: response.data,
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    app.close()
                })
                .catch(error => {
                    console.log(error)
                    let snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    this.selectedRoles = []
                    this.emailList = []
                })
        },
        close() {
            this.$router.push({ name: 'Dashboard' })
        }
    }
}
</script>
